import React, { useEffect, useState } from 'react';
import { Alert } from 'antd';

const formatCountdown = (ms) => {
    const mins = Math.max(0, Math.round(ms / 60000));
    if (mins >= 60) {
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        return m ? `${h} h ${m} min` : `${h} h`;
    }
    return mins <= 1 ? 'about a minute' : `${mins} min`;
};

// Yellow banner counting down to a scheduled maintenance window.
const MaintenanceBanner = ({ messages, now }) => {
    const notice = messages.find((m) => m.kind === 'maintenance' && m.event_at);

    // re-render every 15 s so the countdown moves between polls
    const [, setTick] = useState(0);
    useEffect(() => {
        if (!notice) return undefined;
        const id = setInterval(() => setTick((t) => t + 1), 15000);
        return () => clearInterval(id);
    }, [notice]);

    if (!notice) return null;

    const startsAt = new Date(notice.event_at);
    const remaining = startsAt.getTime() - now();
    const at = startsAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const headline = remaining > 0
        ? `Scheduled maintenance in ${formatCountdown(remaining)} (at ${at})`
        : 'Scheduled maintenance is starting';

    return (
        <Alert
            type="warning"
            showIcon
            banner
            message={headline}
            description={notice.body}
            style={{ marginBottom: 16 }}
        />
    );
};

export default MaintenanceBanner;
